/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FilterCondition } from './FilterCondition';
import {
  instanceOfFilterCondition,
  FilterConditionFromJSON,
  FilterConditionFromJSONTyped,
  FilterConditionToJSON,
} from './FilterCondition';
import type { FilterGroup } from './FilterGroup';
import {
  instanceOfFilterGroup,
  FilterGroupFromJSON,
  FilterGroupFromJSONTyped,
  FilterGroupToJSON,
} from './FilterGroup';

/**
 * @type Query
 * Represents a user-inputed query with nested and/or properties.
 * @export
 */
export type Query = FilterCondition | FilterGroup;

export function QueryFromJSON(json: any): Query {
  return QueryFromJSONTyped(json, false);
}

export function QueryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Query {
  if (json == null) {
    return json;
  }
  if (instanceOfFilterCondition(json)) {
    return FilterConditionFromJSONTyped(json, true);
  }
  if (instanceOfFilterGroup(json)) {
    return FilterGroupFromJSONTyped(json, true);
  }
}

export function QueryToJSON(value?: Query | null): any {
  if (value == null) {
    return value;
  }

  if (instanceOfFilterCondition(value)) {
    return FilterConditionToJSON(value as FilterCondition);
  }
  if (instanceOfFilterGroup(value)) {
    return FilterGroupToJSON(value as FilterGroup);
  }

  return {};
}
